import React from "react";
import { Link } from "react-router-dom";
import config from "../config/config";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {

  return (
    <>
      <footer className="">
      <div className="footercp1"></div>
        <div className="footercp4"></div>
        <Container>
          <Row className="align-items-center mb-4">
            <Col lg={5}>
              <div className="footer-logo">
                <img src="assets/images/f-logo.png" />
              </div>
            </Col>
            <Col lg={7} className="text-right">
              <div className="footer-widget">
                <ul className="mb-0 justify-content-lg-end align-items-center footerlink justify-content-start gap-4 sofia-sans" style={{display: "flex",
    alignItems: "center",
    flexWrap: "wrap"}} >
                  <li className="m-0">
                    <Link to={`${config.baseUrl}termsandconditions`} target="_blank">Terms & Conditons</Link>
                  </li>
                  <li className="m-0">
                    <Link to={`${config.baseUrl}privacypolicy`} target="_blank">Privacy Policy</Link>
                  </li>
                  <li className="m-0">
                    <Link to={`${config.baseUrl}faq`} target="_blank" >FAQ</Link>
                  </li>
                  <li className="m-0">
                    <Link to={`${config.baseUrl}newcontactus`}>Contact Us</Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mb-5 ">
            <Col lg={4}>
              <div className="plogo d-flex align-items-center">
                <div className="  footerproduct">
                  <p className="mb-0 text-light-grey sofia-sans">Product by :</p>
                  <a href="https://mrmint.io/" target="_blank">
                    <img
                      src="assets/images/mrmint.svg"
                      className="mrmintlogo"
                      width="120px"
                      alt=""
                    />
                  </a>
                </div>
                {/* <div>
                  <p className="mb-0 text-light-grey sofia-sans">Tech Partner :</p>
                  <a href="https://espsofttech.com/" target="_blank">
                    <img
                      src="assets/images/esplogo.svg"
                      className="esplogo"
                      width="120px"
                      alt=""
                    />
                  </a>
                </div> */}
              </div>
            </Col>
            <Col lg={8} className="text-right">
              <div className="footer-block">
                <div className="social-icon d-flex justify-content-md-end justify-content-start my-3  mb-2">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/profile.php?id=61551542573562"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={32}
                      height={32}
                      viewBox="0 0 36 36"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.8215 12.4395C21.2798 12.3311 20.5482 12.2502 20.0881 12.2502C18.8422 12.2502 18.7613 12.7919 18.7613 13.6586V15.2015H21.8757L21.6042 18.3975H18.7613V28.1187H14.8617V18.3975H12.8574V15.2015H14.8617V13.2246C14.8617 10.5167 16.1344 9 19.3297 9C20.4399 9 21.2524 9.16251 22.3084 9.37919L21.8215 12.4395Z"
                        fill="#D3D3D3"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_365_1851"
                          x1="0.818181"
                          y1="21.6"
                          x2="29.0916"
                          y2="34.425"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#41D2FF" />
                          <stop offset="0.473958" stopColor="#7E42FF" />
                          <stop offset="0.961901" stopColor="#DD3FFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://t.me/+EGFly7Bwyns1ZWM1"
                    rel="noreferrer"
                    className="w-auto text-end"
                   
                   
                  >
               
                 <div className="f-ic" style={{width:32 , height:32}}>
                 <img src="assets/images/broadcast.png"  alt=""  color="white" />
                 </div>
                  </a>
                  <a
                    target="_blank"
                    href="https://t.me/+QXZoyCAEwAtiYThl"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="32"
                      height="32"
                      viewBox="0 0 256 256"
                      style={{padding:"5px"}}
                    >
                      <g
                        fillOpacity="0"
                        fill="#000000"
                        fillRule="nonzero"
                        stroke="none"
                        strokeWidth="1"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="10"
                        strokeDasharray=""
                        strokeDashoffset="0"
                        fontFamily="none"
                        fontWeight="none"
                        fontSize="none"
                        textAnchor="none"
                        style={{ mixBlendMode: "normal" }}
                      >
                        <path d="M0,256v-256h256v256z" id="bgRectangle"></path>
                      </g>
                      <g
                        fill="#fffcfc"
                        fillRule="nonzero"
                        stroke="none"
                        strokeWidth="1"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="10"
                        strokeDasharray=""
                        strokeDashoffset="0"
                        fontFamily="none"
                        fontWeight="none"
                        fontSize="none"
                        textAnchor="none"
                        style={{ mixBlendMode: "normal" }}
                      >
                        <g transform="scale(5.12,5.12)">
                          <path d="M44.37695,5.98633c-0.48705,0.02137 -0.96114,0.15692 -1.38867,0.32813c-0.42317,0.17006 -2.8594,1.20989 -6.45703,2.74805c-3.59763,1.53816 -8.27429,3.54117 -12.91016,5.52734c-9.27174,3.97235 -18.38281,7.88086 -18.38281,7.88086l0.06641,-0.02539c0,0 -0.5499,0.18381 -1.10742,0.57227c-0.27876,0.19423 -0.57866,0.44498 -0.82422,0.81055c-0.24556,0.36557 -0.42507,0.88366 -0.35742,1.43164c0.23762,1.92475 2.23242,2.4707 2.23242,2.4707l0.00781,0.00391l8.90234,3.04688c0.22697,0.75718 2.70012,9.01167 3.24414,10.75977c0.30045,0.96647 0.58167,1.52398 0.875,1.9043c0.14679,0.19032 0.30062,0.3376 0.4707,0.44531c0.06758,0.04279 0.13865,0.0749 0.20898,0.10352c0.0015,0.00066 0.00241,-0.00066 0.00391,0c0.00864,0.00381 0.01677,0.00415 0.02539,0.00781l-0.02344,-0.00586c0.01634,0.0066 0.03247,0.01771 0.04883,0.02344c0.03174,0.01112 0.05119,0.01074 0.0918,0.01953c1.01954,0.35598 1.86328,-0.30469 1.86328,-0.30469l0.03516,-0.02734l5.46875,-5.07227l8.875,6.91992l0.11133,0.05078c1.55345,0.68975 2.95832,0.30493 3.73633,-0.32812c0.77801,-0.63306 1.08398,-1.44922 1.08398,-1.44922l0.0332,-0.08594l6.52148,-33.99023c0.16687,-0.76044 0.19058,-1.41775 0.0332,-2.01172c-0.15738,-0.59397 -0.53974,-1.1103 -1.01953,-1.39648c-0.47979,-0.28619 -0.9817,-0.37879 -1.46875,-0.35742zM44.42969,8.01953c0.1978,-0.00916 0.34441,0.01345 0.39062,0.04102c0.04621,0.02756 0.06696,0.02394 0.11133,0.19141c0.04437,0.16747 0.0684,0.52021 -0.05273,1.07227l-0.00391,0.01172l-6.48437,33.79297c-0.01535,0.03402 -0.15047,0.34662 -0.45898,0.59766c-0.31473,0.25609 -0.66477,0.45599 -1.59375,0.06641l-9.70508,-7.56836l-0.27344,-0.21484l-0.00586,0.00586l-2.90234,-2.17773l16.31055,-19.18945c0.25603,-0.30045 0.31139,-0.72339 0.1413,-1.0796c-0.17009,-0.35622 -0.5338,-0.57906 -0.92841,-0.56883c-0.18875,0.0049 -0.37226,0.06314 -0.5293,0.16797l-23.60156,15.73438l-8.91602,-3.05273c0,0 -0.88536,-0.49268 -0.92773,-0.83594c-0.00235,-0.01902 -0.0128,-0.0018 0.0332,-0.07031c0.04601,-0.06849 0.16165,-0.18413 0.30664,-0.28516c0.28998,-0.20204 0.62109,-0.32422 0.62109,-0.32422l0.0332,-0.01172l0.0332,-0.01367c0,0 9.11155,-3.90871 18.38281,-7.88086c4.63563,-1.98607 9.31146,-3.98761 12.9082,-5.52539c3.59582,-1.53738 6.19406,-2.64398 6.41406,-2.73242c0.25046,-0.1003 0.49946,-0.14123 0.69727,-0.15039zM33.61328,18.79297l-12.36914,14.55273l-0.00586,0.00586c-0.01931,0.02325 -0.03756,0.04736 -0.05469,0.07227c-0.01962,0.02706 -0.03787,0.05509 -0.05469,0.08398c-0.06949,0.11795 -0.11403,0.24891 -0.13086,0.38477c-0.00001,0.0026 -0.00001,0.00521 0,0.00781l-1.61133,7.24609c-0.02679,-0.07829 -0.04555,-0.10693 -0.07422,-0.19922v-0.00195c-0.51179,-1.64446 -2.84514,-9.42921 -3.16797,-10.50586zM22.64063,35.73047l2.22266,1.66797l-3.26562,3.02734z"></path>
                        </g>
                      </g>
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://twitter.com/step_mint"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="32"
                      height="32"
                      viewBox="0 0 256 256"
                      style={{
                        padding: "5px",

                        fill: "#fffcfc",
                        fillRule: "nonzero",
                        stroke: "none",
                        strokeWidth: "1",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: "10",
                        strokeDasharray: "",
                        strokeDashoffset: "0",
                        fontFamily: "none",
                        fontWeight: "none",
                        fontSize: "none",
                        textAnchor: "none",
                        mixBlendMode: "normal",
                      }}
                    >
                      <g transform="scale(5.12,5.12)">
                        <path d="M5.91992,6l14.66211,21.375l-14.35156,16.625h3.17969l12.57617,-14.57812l10,14.57813h12.01367l-15.31836,-22.33008l13.51758,-15.66992h-3.16992l-11.75391,13.61719l-9.3418,-13.61719zM9.7168,8h7.16406l23.32227,34h-7.16406z"></path>
                      </g>
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/stepmint/about/?viewAsMember=true"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={32}
                      height={32}
                      viewBox="0 0 36 36"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.1494 10.9848C13.1494 12.0668 12.3255 12.9425 11.0371 12.9425C9.79895 12.9425 8.97508 12.0668 9.00058 10.9848C8.97508 9.85016 9.79893 9 11.0618 9C12.3255 9 13.1247 9.85016 13.1494 10.9848ZM9.10416 27.0924V14.489H13.0211V27.0916H9.10416V27.0924Z"
                        fill="#D3D3D3"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.1602 18.5104C16.1602 16.9384 16.1084 15.5982 16.0566 14.4899H19.4589L19.6397 16.2165H19.717C20.2326 15.4173 21.521 14.207 23.6085 14.207C26.1853 14.207 28.1183 15.9082 28.1183 19.6179V27.0933H24.2013V20.1088C24.2013 18.4841 23.6348 17.3766 22.2173 17.3766C21.1345 17.3766 20.4907 18.124 20.2334 18.8451C20.1298 19.1032 20.0788 19.4634 20.0788 19.8251V27.0933H16.1618V18.5104H16.1602Z"
                        fill="#D3D3D3"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_365_1861"
                          x1="0.818181"
                          y1="21.6"
                          x2="29.0916"
                          y2="34.425"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#41D2FF" />
                          <stop offset="0.473958" stopColor="#7E42FF" />
                          <stop offset="0.961901" stopColor="#DD3FFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                  <a
                    target="_blank"
                    href="https://instagram.com/stepmint?igshid=MzMyNGUyNmU2YQ=="
                    className="mr-0"
                    rel="noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={32}
                      height={32}
                      viewBox="0 0 36 36"
                      fill="none"
                    >
                      <path
                        d="M18.1423 9.59333C20.9267 9.59333 21.2566 9.60397 22.3562 9.65414C23.373 9.70051 23.9252 9.87039 24.2926 10.0132C24.7794 10.2024 25.1268 10.4284 25.4917 10.7933C25.8566 11.1582 26.0826 11.5056 26.2718 11.9924C26.4146 12.3598 26.5845 12.912 26.6308 13.9288C26.681 15.0284 26.6917 15.3582 26.6917 18.1427C26.6917 20.9272 26.681 21.257 26.6308 22.3567C26.5845 23.3734 26.4146 23.9256 26.2718 24.2931C26.0826 24.7798 25.8566 25.1272 25.4917 25.4921C25.1268 25.8571 24.7794 26.083 24.2926 26.2722C23.9252 26.415 23.373 26.5849 22.3562 26.6313C21.2568 26.6814 20.927 26.6921 18.1423 26.6921C15.3576 26.6921 15.0278 26.6814 13.9283 26.6313C12.9115 26.5849 12.3594 26.415 11.9919 26.2722C11.5051 26.083 11.1577 25.8571 10.7928 25.4921C10.4279 25.1272 10.2019 24.7798 10.0127 24.2931C9.86991 23.9256 9.70003 23.3734 9.65366 22.3567C9.60349 21.257 9.59285 20.9272 9.59285 18.1427C9.59285 15.3582 9.60349 15.0284 9.65366 13.9288C9.70003 12.912 9.86991 12.3598 10.0127 11.9924C10.2019 11.5056 10.4279 11.1582 10.7928 10.7933C11.1577 10.4284 11.5051 10.2024 11.9919 10.0132C12.3594 9.87039 12.9115 9.70051 13.9283 9.65414C15.0279 9.60397 15.3578 9.59333 18.1423 9.59333ZM18.1423 7.71436C15.3101 7.71436 14.9549 7.72636 13.8426 7.77711C12.7327 7.82774 11.9746 8.00404 11.3113 8.26181C10.6255 8.52831 10.0439 8.88489 9.46415 9.46464C8.88441 10.0444 8.52783 10.626 8.26136 11.3117C8.00355 11.9751 7.82725 12.7331 7.77662 13.8431C7.72587 14.9554 7.71387 15.3105 7.71387 18.1427C7.71387 20.9749 7.72587 21.33 7.77662 22.4423C7.82725 23.5523 8.00355 24.3104 8.26136 24.9737C8.52783 25.6594 8.88441 26.241 9.46415 26.8208C10.0439 27.4005 10.6255 27.7571 11.3113 28.0236C11.9746 28.2814 12.7327 28.4577 13.8426 28.5083C14.9549 28.5591 15.3101 28.5711 18.1423 28.5711C20.9744 28.5711 21.3296 28.5591 22.4419 28.5083C23.5518 28.4577 24.3099 28.2814 24.9732 28.0236C25.659 27.7571 26.2406 27.4005 26.8204 26.8208C27.4001 26.241 27.7567 25.6594 28.0232 24.9737C28.281 24.3104 28.4573 23.5523 28.5079 22.4423C28.5586 21.33 28.5706 20.9749 28.5706 18.1427C28.5706 15.3105 28.5586 14.9554 28.5079 13.8431C28.4573 12.7331 28.281 11.9751 28.0232 11.3117C27.7567 10.626 27.4001 10.0444 26.8204 9.46464C26.2406 8.88489 25.659 8.52831 24.9732 8.26181C24.3099 8.00404 23.5518 7.82774 22.4419 7.77711C21.3296 7.72636 20.9744 7.71436 18.1423 7.71436Z"
                        fill="#D3D3D3"
                      />
                      <path
                        d="M18.1462 12.792C15.1886 12.792 12.791 15.1895 12.791 18.1471C12.791 21.1047 15.1886 23.5022 18.1462 23.5022C21.1037 23.5022 23.5012 21.1047 23.5012 18.1471C23.5012 15.1895 21.1037 12.792 18.1462 12.792ZM18.1462 21.6232C16.2263 21.6232 14.67 20.0669 14.67 18.1471C14.67 16.2273 16.2263 14.671 18.1462 14.671C20.066 14.671 21.6223 16.2273 21.6223 18.1471C21.6223 20.0669 20.066 21.6232 18.1462 21.6232Z"
                        fill="#D3D3D3"
                      />
                      <path
                        d="M24.9647 12.5766C24.9647 13.2677 24.4044 13.828 23.7133 13.828C23.0222 13.828 22.4619 13.2677 22.4619 12.5766C22.4619 11.8855 23.0222 11.3252 23.7133 11.3252C24.4044 11.3252 24.9647 11.8855 24.9647 12.5766Z"
                        fill="#D3D3D3"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_365_1868"
                          x1="0.818181"
                          y1="21.6"
                          x2="29.0916"
                          y2="34.425"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#41D2FF" />
                          <stop offset="0.473958" stopColor="#7E42FF" />
                          <stop offset="0.961901" stopColor="#DD3FFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </div>
                <a
                  className="text-light-grey mt-2 text-decoration-none sofia-sans"
                  href="mailto:info@stepmint.io"
                >
                  info@stepmint.io
                </a>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="copyright">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} className="text-center">
                <p className="sofia-sans">
                  When you visit or interact with our site, services, or tools,
                  we or our authorised service providers may use cookies for
                  storing information to provide you with a better, faster, and
                  safer experience. It is also used for marketing purposes.
                </p>
              </Col>
              <hr />
              <Col lg={12} className="text-center mb-3">
              <a className="text-light-grey sofia-sans"  href="#"> © 2025 Stepmint. All Rights Reserved</a>
              </Col>
              <hr />
            </Row>
          </Container>
        </div>
      </footer>
    </>
  );
};
export default Footer;
